import {
  Condition,
  QueryTranslator,
  TranslatedQuery,
} from '@ajax/vue/components/templates/item-list/condition/contactlens/model/condition'

/**
 * 条件オブジェクトの値がEngineのtag.pathname、ないしそれに準じるデータから構築されていると前提して、
 * Frontへのクエリ形式に変換する
 * @param queryKey
 */
export const translateFromEngineTagPathname = translateWith(v => v.split('.').reverse()[0])
/**
 * Conditionオブジェクトの値について、特に処理を挟まず直接クエリに変換する
 */
export const translateDirectly = translateWith(v => v)

function translateWith(f: (v: Condition['value']) => Condition['value']) {
  return (queryKey: string): QueryTranslator => ({
    translate(conditions: Condition[]): TranslatedQuery {
      const values = conditions.map(cond => f(cond.value))

      return new TranslatedQuery({ [queryKey]: values.join(',') })
    },
  })
}
